<template>
  <div class="referrer_box">
    <el-row>
      <el-col :span="12">
        <span class="page-title">My Enquiries</span>
      </el-col>
      <el-col :span="12" class="back-col">
        <span @click="goBack()" class="btn-back"><i class="el-icon-arrow-left"></i>BACK</span>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-col :span="24">
        <el-collapse v-model="activeNames">
          <el-collapse-item name="1" v-show="isSuperAdmin() || isElite()">
            <template v-slot:title>
              <span class="accordion-title">Register Buyer Details</span>
            </template>
            <enquiry-table/>
          </el-collapse-item>
          <el-collapse-item name="2" v-show="isSuperAdmin() || isBaseOrProOrElite()">
            <template v-slot:title>
              <span class="accordion-title">Concierge Referrals via Listing</span>
            </template>
            <referred-clients-table/>
          </el-collapse-item>
          <el-collapse-item name="3" v-show="isSuperAdmin() || isBaseOrProOrElite()">
            <template v-slot:title>
              <span class="accordion-title">Concierge Referrals</span>
            </template>
            <concierge-referral-table/>
          </el-collapse-item>
          <el-collapse-item name="4" v-show="isSuperAdmin() || isBaseOrProOrElite()">
            <template v-slot:title>
              <span class="accordion-title">Property Requests</span>
            </template>
            <property-requests-table/>
          </el-collapse-item>
        </el-collapse>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import EnquiryTable from "./enquiryTable.vue";
import ReferredClientsTable from "./referredClientsTable.vue";
import {mapActions} from "vuex";
import ConciergeReferralTable from "./conciergeReferralTable.vue";
import PropertyRequestsTable from "./propertyRequestsTable.vue";

export default {
  name: 'conciergeEnquiries',
  components: {PropertyRequestsTable, ConciergeReferralTable, ReferredClientsTable, EnquiryTable },
  data() {
    return {
      activeNames: ['1', '2'],
      adminRolePermission: ''
    }
  },
  created() {
    this.getPermission({params: {}, callback: this.callback})
  },
  methods: {
    ...mapActions(["getPermission"]),
    goBack() {
      this.$router.go(-1)
    },
    callback(res, status) {
      switch (status) {
        case 'getPermission':
          if (res.code === 0) {
            this.adminRolePermission = res.data.rolePermission;
          } else if (res.code === 90000 || res.code === 90002 || res.code === 90001) {
            localStorage.clear()
            this.$router.push('/login')
          } else if (res.code === 8902 || res.code === 8901) {
            this.$box.alert('', res.data.message, 'error')
            localStorage.clear()
            this.$router.push('/login')
          } else if (res.code === 20001) {
            this.$router.push('/')
          } else {
            this.$box.alert('', res.message, 'error')
          }
          break;
        default:
          break;
      }
    },
    isElite() {
      let adminRole = localStorage.getItem('role');

      if (adminRole === '3' || adminRole === '2') {
        return true;
      } else if (adminRole === '4') {
        return this.adminRolePermission === 'UCON_STND_ELITE'
          || this.adminRolePermission === 'UCON_STND_ELITE_NEW'
          || this.adminRolePermission === 'UCON_CORP_PREM';
      }else {
        return false;
      }
    },
    isBaseOrProOrElite() {
      let adminRole = localStorage.getItem('role');
      if (adminRole === '4') {
        return this.adminRolePermission === 'UCON_STND_BAS'
          || this.adminRolePermission === 'UCON_STND_PRO'
          || this.adminRolePermission === 'UCON_STND_ELITE'
          || this.adminRolePermission === 'UCON_STND_ELITE_NEW';
      }else {
        return false;
      }
    },
    isSuperAdmin() {
      let adminRole = localStorage.getItem('role');
      return adminRole === '1';
    }
  },
}
</script>

<style lang='scss'>
.referrer_box {
  border-radius: 0 0 5px 5px;
  background-color: #ffffff;
  padding: 20px 10px 0 10px;
}

.btn-back {
  color: #003333;
  font-weight: 600;
  font-size: 24px;
  line-height: 125%;
  cursor: pointer;
  text-decoration: underline;
}

.back-col {
  display: flex;
  justify-content: flex-end;
}

.page-title {
  color: #003333;
  font-weight: 600;
  font-size: 24px;
}

.accordion-title {
  color: #003333;
  font-weight: 600;
  font-size: 22px;
  line-height: 125%;
}


.info-item {
  border: 1px solid #EBEEF5;
  border-radius: 4px;
  padding: 10px;
  background-color: #fff;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.info-label {
  font-size: 13px;
  font-weight: 600;
  color: #909399;
  margin-bottom: 8px;
}

.info-label i {
  margin-right: 4px;
}

.info-content {
  font-size: 14px;
  color: #606266;
  line-height: 1.5;
  flex: 1;
  display: flex;
  align-items: center;
}

.empty-text {
  color: #C0C4CC;
  font-style: italic;
}
</style>



// WEBPACK FOOTER //
// src/components/enquiry/conciergeEnquiries.vue